import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import TierIcon from '@wix/da-ds/pkg/Icons/24x24/Tier';
import TierIconSmall from '@wix/da-ds/pkg/Icons/16x16/Tier';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { LoggedOutReturnType } from '../../../redux/loggedout';
import { formatPrice } from '../../../DeviationViews/TierProductCardDumb/utils';
import { DeviationResourceType } from '../../../types/deviation';
import s from './Subscribe.scss';
const SubscribeVariant = ({ tier , tier: { tier: { dollarPrice  } = {}  } , withPrice =false , size ='medium' , className , href , onSubscribe  })=>{
    var _tier_tier, _tier_tier1;
    const { t  } = useTranslation();
    const newSubscribeButtons = useFlag('subscribe_btns');
    const { restrictToLoggedIn  } = useRestrictToLoggedIn();
    const subscribe = restrictToLoggedIn(ReferralType.MEMBER_SUBSCRIBE, onSubscribe, ((_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.subproductId) ? Url.checkoutLink((_tier_tier1 = tier.tier) === null || _tier_tier1 === void 0 ? void 0 : _tier_tier1.subproductId) : undefined, LoggedOutReturnType.JOIN_ONLY);
    const showPrice = withPrice && dollarPrice;
    const ButtonComponent = newSubscribeButtons ? SolidButton : BrandedButton;
    return /*#__PURE__*/ React.createElement(ButtonComponent, {
        isFakeButton: true,
        className: c(s['root'], className),
        icon: newSubscribeButtons ? size === 'small' ? TierIconSmall : TierIcon : undefined,
        size: size,
        variant: newSubscribeButtons ? 'main' : 'brand-green',
        href: href,
        onClick: (e)=>{
            if (!onSubscribe) {
                return;
            }
            subscribe(tier);
            e.stopPropagation();
            e.preventDefault();
        },
        biData: {
            evid: BiEventType.TIER_SUBSCRIBE,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId
        }
    }, showPrice ? t('deviation.tier.subscribeWithPrice', {
        dollarPrice: formatPrice(dollarPrice)
    }) : t('deviation.tier.subscribe'));
};
SubscribeVariant.displayName = 'SubscribeVariant';
export default SubscribeVariant;
